/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_TitleInputs */

const en_pc_online_cmp_title = /** @type {(inputs: Pc_Online_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online vs the desktop app`)
};

const zh_pc_online_cmp_title = /** @type {(inputs: Pc_Online_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版与桌面版对比`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online vs the desktop app" |
*
* @param {Pc_Online_Cmp_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_title = /** @type {((inputs?: Pc_Online_Cmp_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_title(inputs)
	return zh_pc_online_cmp_title(inputs)
});
export { pc_online_cmp_title as "pc.online.cmp_title" }